/**
 * 매장관리자 홈 Container
 * --
 */
import React from 'react';
// import MainHomePresenter from './MainHomePresenter';
import HomeDashboard from 'routes/admin.routes/admin.dashboard/HomeDashboard';
import { useUserStack } from 'store';

const MainHomeContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <HomeDashboard
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
          shopType={'STORE'}
        />
      )}
    </>
  );
};

export default MainHomeContainer;
